import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AuthService } from "@/integrations/api/services/authService";
import App from "./App.tsx";
import "./index.css";

// SSO handoff from Prosparity 2W: #token=<jwt> must be stored before router/auth mounts
AuthService.consumeSsoTokenFromHash();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
